import { safeFormatISODate } from '../../../util/datetime-fns';
import type { CarState } from '../carDefaultState';

export const buildCarTrackingItem = (state: Partial<CarState>) => ({
    id: 'finntravel',
    type: 'Travel',
    destination: state.pickupLocation,
    travelType: 'carrental',
    departureDate: `${safeFormatISODate(state.pickupDate)}T${state.pickupTime}:00.000Z`,
    returnDate: `${safeFormatISODate(state.returnDate)}T${state.returnTime}:00.000Z`,
});
